import React, { useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  ListItemText,
  OutlinedInput,
  Chip,
} from "@mui/material";
import { fetchWithToken } from "../../../api/apiutils";

const SEGMENTS = [
  { code: "S0.1", label: "Мёртвые — не открыли" },
  { code: "S0.2", label: "Мёртвые — открыл и пропал" },
  { code: "S1.1", label: "Редко заходит" },
  { code: "S1.2", label: "Регулярно заходит" },
  { code: "S1.3", label: "Горячий — не платит" },
  { code: "S2.1", label: "Триал — активен" },
  { code: "S2.2", label: "Триал — не использует" },
  { code: "S2.3", label: "Триал истёк" },
  { code: "S3", label: "Платные" },
  { code: "S4", label: "Продление через 7 дней" },
  { code: "S5.1", label: "Ушёл после 1 мес" },
  { code: "S5.2", label: "Ушёл после 2+ мес" },
];

const ActiveUserFilter = ({ initialFilters, onApply, onClear, onExport }) => {
  const [activityLevels, setActivityLevels] = useState([]);
  const [draft, setDraft] = useState(initialFilters || {});

  useEffect(() => {
    setDraft(initialFilters || {});
  }, [initialFilters]);

  useEffect(() => {
    let ignore = false;
    async function loadActivityLevels() {
      try {
        const res = await fetchWithToken("/api/dictionary/ActivityLevels");
        const json = await res.json();
        if (!ignore) setActivityLevels(Array.isArray(json) ? json : []);
      } catch (e) {
        console.error("Error fetching activity levels:", e);
      }
    }
    loadActivityLevels();
    return () => (ignore = true);
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setDraft((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDraft = (name, value) => {
    setDraft((prev) => ({ ...prev, [name]: value }));
  };

  const handleApply = () => {
    console.log("asd");
    onApply(draft);
  };
  const handleClear = () => onClear();

  const selectedSegments = draft.segmentCodes || [];

  return (
    <div className="user-list-container">
      <form className="user-form">
        {/* ...existing FormControl'ы (Период, Вид подписки, Активность) без изменений... */}

        <FormControl variant="filled" sx={{ m: 1, minWidth: 220, margin: 0 }}>
          <InputLabel>Сегмент</InputLabel>
          <Select
            multiple
            name="segmentCodes"
            value={selectedSegments}
            onChange={(e) => handleDraft("segmentCodes", e.target.value)}
            input={<OutlinedInput label="Сегмент" />}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((code) => (
                  <Chip key={code} label={code} size="small" />
                ))}
              </Box>
            )}
          >
            {SEGMENTS.map((seg) => (
              <MenuItem key={seg.code} value={seg.code}>
                <Checkbox checked={selectedSegments.indexOf(seg.code) > -1} />
                <ListItemText primary={`${seg.code} — ${seg.label}`} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          variant="filled"
          sx={{ m: 1, minWidth: 165.233, margin: 0 }}
        >
          <InputLabel>Период</InputLabel>
          <Select
            name="period"
            value={draft.period || ""}
            onChange={handleChange}
          >
            <MenuItem value="today">За сегодня</MenuItem>
            <MenuItem value="week">За неделю</MenuItem>
            <MenuItem value="month">За месяц</MenuItem>
            <MenuItem value="quarter">За квартал</MenuItem>
            <MenuItem value="year">За год</MenuItem>
            <MenuItem value="all">За всё время</MenuItem>{" "}
          </Select>
        </FormControl>

        <FormControl
          variant="filled"
          sx={{ m: 1, minWidth: 165.233, margin: 0 }}
        >
          <InputLabel>Вид подписки</InputLabel>
          <Select
            name="subscriptionType"
            value={draft.subscriptionType || ""}
            onChange={handleChange}
          >
            <MenuItem value="Обычный пользователь">
              Обычный пользователь
            </MenuItem>
            <MenuItem value="Демо подписка">Демо подписка</MenuItem>
            <MenuItem value="Colibri PRO">Colibri PRO</MenuItem>
            <MenuItem value="Просрочена подписка">Просрочена подписка</MenuItem>
          </Select>
        </FormControl>

        <FormControl
          variant="filled"
          sx={{ m: 1, minWidth: 165.233, margin: 0 }}
        >
          <InputLabel>Активность</InputLabel>
          <Select
            name="activityLevel"
            value={draft.activityLevel || ""}
            onChange={handleChange}
          >
            {activityLevels.map((level) => (
              <MenuItem key={level.id} value={level.id}>
                {level.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box
          display="flex"
          gap={2}
          mt={2}
          sx={{ m: 1, minWidth: 165.233, margin: 0 }}
        >
          <TextField
            type="date"
            name="registerDateFrom"
            label="Регистрация с"
            sx={{ width: 190 }}
            InputLabelProps={{ shrink: true }}
            value={draft.registerDateFrom || ""}
            onChange={handleChange}
          />
          <TextField
            type="date"
            name="registerDateTo"
            label="Регистрация до"
            sx={{ width: 190 }}
            InputLabelProps={{ shrink: true }}
            value={draft.registerDateTo || ""}
            onChange={handleChange}
          />
        </Box>

        <Box
          display="flex"
          gap={2}
          mt={2}
          sx={{ m: 1, minWidth: 165.233, margin: 0 }}
        >
          <TextField
            type="date"
            name="subscriptionActivatedFrom"
            label="Активация подписки с"
            sx={{ width: 190 }}
            InputLabelProps={{ shrink: true }}
            value={draft.subscriptionActivatedFrom || ""}
            onChange={handleChange}
          />
          <TextField
            type="date"
            name="subscriptionActivatedTo"
            label="Активация подписки до"
            sx={{ width: 190 }}
            InputLabelProps={{ shrink: true }}
            value={draft.subscriptionActivatedTo || ""}
            onChange={handleChange}
          />
        </Box>

        <FormControlLabel
          control={
            <Checkbox
              name="isSubscribed"
              checked={Boolean(draft.isSubscribed)}
              onChange={handleChange}
            />
          }
          label="Активировал подписку"
          sx={{ m: 1 }}
        />

        <Box
          display="flex"
          gap={2}
          mt={2}
          sx={{ m: 1, minWidth: 300, flex: "1 1 300px", margin: 0 }}
        >
          <TextField
            label="Поиск"
            value={draft.search || ""}
            onChange={(e) => handleDraft("search", e.target.value)}
            fullWidth
          />
        </Box>
        {/* ...остальная форма без изменений... */}
      </form>

      <Box className="action-buttons" display="flex" gap={1}>
        <Button variant="contained" color="primary" onClick={handleApply}>
          Применить
        </Button>
        <Button variant="contained" color="error" onClick={handleClear}>
          Очистить
        </Button>
        <Button variant="contained" color="success" onClick={onExport}>
          Выгрузить в Excel
        </Button>
      </Box>
    </div>
  );
};

export default ActiveUserFilter;
